/**
 * Vehicle category type values
 */
export enum VehicleCategoryTypeEnum {
	CAR = 'car',
	CAR_MINI = 'car-mini',
	CAR_COMPACT = 'car-compact',
	CAR_ECONOMY = 'car-economy',
	CAR_HATCHBACK = 'car-hatchback',
	CAR_SEDAN = 'car-sedan',
	CAR_COUPE = 'car-coupe',
	CAR_CONVERTIBLE = 'car-convertible',
	CAR_WAGON = 'car-wagon',
	CAR_LUXURY = 'car-luxury',
	CAR_SPORTS = 'car-sports',

	SUV = 'suv',
	SUV_SMALL = 'suv-small',
	SUV_MEDIUM = 'suv-medium',
	SUV_CROSSOVER = 'suv-crossover',
	SUV_LARGE = 'suv-large',
	SUV_LUXURY = 'suv-luxury',

	VAN = 'van',
	VAN_CARGO = 'van-cargo',
	VAN_PASSENGER = 'van-passenger',
	VAN_PASSENGER_LUXURY = 'van-passenger-luxury',

	MOTO = 'moto',
	MOTO_SCOOTER = 'moto-scooter',
	MOTO_SCOOTER_MAXI = 'moto-scooter-maxi',
	MOTO_CRUISER = 'moto-cruiser',
	MOTO_TOURING = 'moto-touring',
	MOTO_SPORT_BIKE = 'moto-sport-bike',
	MOTO_ADVENTURE = 'moto-adventure',

	BIKE = 'bike',
	BIKE_CITY = 'bike-city',
	BIKE_MOUNTAIN = 'bike-mountain',
	BIKE_ELECTRIC = 'bike-electric',

	BUGGY = 'buggy',
	BUGGY_OFF_ROAD = 'buggy-off-road',
	BUGGY_STREET = 'buggy-street',

	ATV = 'atv',
	ATV_OFF_ROAD = 'atv-off-road',
	ATV_STREET = 'atv-street',

	SPECIAL_EXOTIC = 'special-exotic',
	SPECIAL_CLASSIC = 'special-classic',
}
